import { FC } from "react";
import { CheckBoxProps } from "./types";
import { Row } from "../../containers";
import { CheckIcon } from "../../../assets/icons";
import { Text } from "../../typography";
import { useThemeStore } from "../../../stores";
import { JustifyContent } from "../../containers/types";

const CheckBox: FC<CheckBoxProps> = ({
  color,
  label,
  value,
  props,
  size = 16,
  setValue = () => {},
  className = "",
  style = {},
  readOnly = false,
  Icon = CheckIcon,
  activeColor,
}) => {
  const onClick = (): void => {
    if (!readOnly) setValue(!value);
  };
  const theme = useThemeStore((state) => state.theme);
  activeColor = activeColor || theme.primary;
  return (
    <Row
      gap={10}
      style={{ cursor: "pointer", ...style }}
      className={className}
      props={{ onClick, ...props }}
    >
      <Row
        style={{
          width: 20,
          height: 20,
          border: `1px solid ${value ? activeColor : theme.icon}`,
          borderRadius: 7,
        }}
        justifyContent={JustifyContent.Center}
        className="transition"
      >
        {value ? <Icon color={activeColor} /> : <></>}
      </Row>
      <Text size={size} color={color}>
        {label}
      </Text>
    </Row>
  );
};

export default CheckBox;
